export const environment = {
  production: false,

  API_URL: "https://sandbox-api.xcelapp.com",
  TRANSACTION_SERVICE_URL:
    "https://sandbox-api.xcelapp.com/transactions-service",

  USER_SERVICE_URL: "https://sandbox-api.xcelapp.com/user-service",

  ABBAS_API_URL: "https://sandbox-api.xcelapp.com/api",

  FEE_ACCOUNT_ENDPOINT:
    "https://walletapi.etranzactglobal.com/Wallet/Api/Socket/HoldAccount",

  SETTLEMENT_ACCOUNT_ENDPOINT:
    "http://wallet-api-8260ea05a2dcc081.elb.us-west-2.amazonaws.com/Wallet/Api/Socket",

  ADMIN_REPORT_URL: "https://sandbox-api.xcelapp.com/administrator",

  ADMIN_LOAN_URL: "https://api.xcelapp.com/loan",

   ADMIN_AUTH_URL: "https://sandbox-api.xcelapp.com/administrator",
  SUPPORT_SERVICE_URL: "https://api.xcelapp.com/support-service",
  
  XAS_URL: "https://sandbox-api.xcelapp.com/xas/v1",
 
  ESA_URL: "https://sandbox-api.xcelapp.com/esa",

  BUSINESS_API_URL: "https://sandbox-api.xcelapp.com/business-api",
  CONFIG_PRESET: "SgKOr2mJp",

  X_APP_ID: "640b794e6667f7cb1531a666",
  X_ISSUER_ID: "640b794d6667f7cb1531a65f",
  PUBLIC_KEY:
    "eTz.test_e87f28c9934f7a01ee1b4d572414c7155f403fe3589806e3e346ff5d0b432326",
  USER_DEVICES_URL: "https://sandbox-api.xcelapp.com/xas/v1/admin/accounts",

  BROADCAST_API_USER: "admin",
  BROADCAST_API_KEY: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6ImYWlsLmNvbSIsInN1YiI6IjY5NjdjN2M2OTVkYzc1MDViYjJpYXQiOjE3ODcxNTIxNTksImV4cCI6MTc4NzE2Mjk1OX0.yW47OMA9JDdio4pycfNZk9lm2n8pq5rt7wxy1abcd4ef6ghj3kpq5rt7wxy1abcd4ef6ghj3kpq5rt7w",
};



